import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.84 2.054c.673-1.542 2.977-1.047 2.958.635L13.726 9h3.145c1.123 0 1.87 1.16 1.405 2.182l-2.15 4.732a1 1 0 1 1-1.822-.828L16.163 11h-2.897c-.86 0-1.554-.702-1.544-1.56l.051-4.523L8.242 13h2.916c.867 0 1.564.714 1.543 1.581l-.11 4.516.119-.264a1 1 0 1 1 1.822.825l-1.047 2.314c-.694 1.532-2.99 1.008-2.95-.674L10.69 15H7.545a1.543 1.543 0 0 1-1.414-2.161z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: n };
export {
  i as default,
  n as render
};
//# sourceMappingURL=ic_electric-BSysw-pb.js.map
